import { render, staticRenderFns } from "./ChamberInfo.vue?vue&type=template&id=b51eea58&scoped=true"
import script from "./ChamberInfo.vue?vue&type=script&lang=js"
export * from "./ChamberInfo.vue?vue&type=script&lang=js"
import style0 from "./ChamberInfo.vue?vue&type=style&index=0&id=b51eea58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51eea58",
  null
  
)

export default component.exports